/* eslint-disable no-debugger */
/* eslint-disable no-else-return */
import { reduxContentTypes } from 'src/types';
import {
  SIDES_POPULATED,
  FACTIONS_POPULATED,
  PROTOTYPES_POPULATED,
  PROTOTYPES_REMOVED,
  SYSTEMS_POPULATED,
  AMMO_INDEXES_POPULATED,
  SUPPLIES_POPULATED,
  AMMUNITIONS_POPULATED,
  AIRCRAFTS_POPULATED,
  NAVALCRAFTS_POPULATED,
  OBSTACLES_POPULATED,
  COMM_DEVICES_POPULATED,
  AGENTS_POPULATED,
  DELETED_COMMANS_IN_EDITED_COMMANDS,
  ADD_COMMAND,
  EDIT_COMMAND,
  SET_COMMANDS,
  SET_EDITED_COMMANDS,
  RESET_DELETED_COMMANDS_IN_EDITED_COMMANDS,
  SET_SELECTED_ETMEN,
  DELETE_FILTERED_SYSTEMS,
  ADD_COMMAND_RESULT,
  SET_ACTIVE_SIDES,
} from '../../redux-types';

export const contentDefaulState: reduxContentTypes.StateType = {
  sides: [],
  factions: [],
  prototypes: [],
  systems: [],
  ammoIndexes: [],
  filteredSystems: [],
  supplies: [],
  ammunitions: [],
  agents: [],
  aircrafts: [],
  navalcrafts: [],
  obstacles: [],
  commdevices: [],
  commands: [],
  commandGroups: [],
  editedCommands: [],
  deletedEditedCommands: [],
  overlappedEtmenId: undefined,
  commandResults: {
    successfulCommands: [],
    failedCommands: [],
  },
  activeSides: [],
};

export const contentReducer = (
  state = contentDefaulState,
  action: reduxContentTypes.ActionType,
): reduxContentTypes.StateType => {
  let item;
  let index;
  switch (action.type) {
    case SIDES_POPULATED:
      return {
        ...state,
        sides: action.payload,
      };
    case FACTIONS_POPULATED:
      return {
        ...state,
        factions: action.payload,
      };
    case PROTOTYPES_POPULATED:
      return {
        ...state,
        prototypes: action.payload,
      };
    case PROTOTYPES_REMOVED:
      return {
        ...state,
        prototypes: state.prototypes.filter((o) => !action.payload.includes(o.id)),
      };
    case SYSTEMS_POPULATED:
      return {
        ...state,
        systems: action.payload,
      };
    case AMMO_INDEXES_POPULATED:
      return {
        ...state,
        ammoIndexes: action.payload,
      };
    case SUPPLIES_POPULATED:
      return {
        ...state,
        supplies: action.payload,
      };
    case AMMUNITIONS_POPULATED:
      return {
        ...state,
        ammunitions: action.payload,
      };

    case AIRCRAFTS_POPULATED:
      return {
        ...state,
        aircrafts: action.payload,
      };

    case NAVALCRAFTS_POPULATED:
      return {
        ...state,
        navalcrafts: action.payload,
      };

    case OBSTACLES_POPULATED:
      return {
        ...state,
        obstacles: action.payload,
      };

    case COMM_DEVICES_POPULATED:
      return {
        ...state,
        commdevices: action.payload,
      };
    case AGENTS_POPULATED:
      return {
        ...state,
        agents: action.payload,
      };
    case SET_SELECTED_ETMEN:
      return {
        ...state,
        overlappedEtmenId: action.payload,
      };
    case SET_COMMANDS:
      return {
        ...state,
        commands: action.payload,
      };
    case 'SET_COMMAND_GROUPS':
      return {
        ...state,
        commandGroups: action.payload,
      };
    case ADD_COMMAND:
      return {
        ...state,
        commands: [action.payload, ...state.commands],
      };
    case EDIT_COMMAND:
      return {
        ...state,
        commands: state.commands.map((o) => (o.id === action.payload.id ? action.payload : o)),
      };
    case ADD_COMMAND_RESULT:
      return {
        ...state,
        commandResults: {
          successfulCommands: [...state.commandResults.successfulCommands, ...action.payload.successfulCommands],
          failedCommands: [...state.commandResults.failedCommands, ...action.payload.failedCommands],
        },
      };

    case SET_EDITED_COMMANDS:
      item = state.editedCommands.find((o) => o.unitId === action.payload.unitId);
      index = state.editedCommands.findIndex((o) => o.unitId === action.payload.unitId);

      if (item && index !== undefined) {
        return {
          ...state,
          editedCommands: [
            ...state.editedCommands.slice(0, index),
            {
              unitId: action.payload.unitId,
              commands: action.payload.commands,
            },
            ...state.editedCommands.slice(index + 1),
          ],
        };
      } else {
        return {
          ...state,
          editedCommands: [
            ...state.editedCommands,
            {
              unitId: action.payload.unitId,
              commands: action.payload.commands,
            },
          ],
        };
      }

    case RESET_DELETED_COMMANDS_IN_EDITED_COMMANDS:
      return {
        ...state,
        deletedEditedCommands: [],
      };

    case DELETED_COMMANS_IN_EDITED_COMMANDS:
      // eslint-disable-next-line no-case-declarations
      item = state.deletedEditedCommands.find((o) => o === action.payload.commandId);

      if (item) {
        return {
          ...state,
          deletedEditedCommands: state.deletedEditedCommands.filter((o) => o !== action.payload.commandId),
        };
      }
      return {
        ...state,
        deletedEditedCommands: [...state.deletedEditedCommands, action.payload.commandId],
      };

    case DELETE_FILTERED_SYSTEMS:
      return {
        ...state,
        filteredSystems: state.filteredSystems.filter(
          (o) => !(o.unitId === action.payload.unitId && o.tmk.id === action.payload.tmk.id),
        ),
      };

    case SET_ACTIVE_SIDES:
      return {
        ...state,
        activeSides: action.payload,
      };

    default:
      return state;
  }
};
